import React from 'react';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;



let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize13 = 11;
}


class Item extends React.Component {

  handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    if (this.props.onHover) {
      this.props.onHover(this.props.item, rect); // ou this.props.title selon ce que tu passes
    }
  };

  handleMouseLeave = () => {
    if (this.props.onLeave) {
      this.props.onLeave();
    }
  };


  accessStorryPage = () => {
    window.location = `/p/${this.props.item.public_id}`;
  }




  render() {
    const { width, isLast } = this.props;

    return (
      <div
        className="item"
        style={{
          cursor: 'pointer',
          width: `${width}px`,
          height: `${width*9/16}px`,
          marginRight: isLast ? 0 : `${20}px`,
          color: '#fff',
          fontSize: '14px'
        }}
        onClick={this.accessStorryPage}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >

         <div style={{zIndex: 1, position: 'relative', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.2)'}}></div>

          <img src={this.props.item.medias.thumbnail}  className="card-image"/>

          <div className="text-overlay">
            <div className="text-gradient" />
            <p className="overlay-text" style={{fontSize: titleFontSize20+'px', fontWeight: 'bold'}}>{this.props.item.title}</p>
          </div>

      </div>
    );
  }
}

export default Item;
